import { StyledAvatar } from './Avatar.styled';
import { useAudio } from '../../providers/AudioContext';

const Avatar = ({ figure, onMouseEnter, onClick, onMouseLeave = () => {}, isSelected = false, isHovered = false }) => {
  const { playSFX } = useAudio();

  const onAvatarClick = () => {
    if (!isSelected) {
      playSFX('menu_button');
    }
    if (onClick) {
      onClick(figure);
    }
  };

  const onHover = () => {
    playSFX('hover');
    if (onMouseEnter) {
      onMouseEnter();
    }
  };

  return (
    <div onMouseEnter={onHover} onMouseLeave={onMouseLeave} onClick={onAvatarClick}>
      <StyledAvatar $selected={isSelected} $hovered={isHovered}>
        <div className='avatar-border'>
          <div className='avatar-internal-border'>
	    <div style={{overflow: 'hidden', height: '100%', width: '100%'}}>
              <img src={figure.getAvatarThumbSource()} />
            </div>
          </div>
        </div>
	<div className='avatar-decorator'>
          <div />
        </div>
      </StyledAvatar>
    </div>
  );
};

export default Avatar;
